const SAFE_HREF_PROTOCOLS = new Set(['http:', 'https:']);

/** Guards anchor `href` sinks against stored XSS: returns the value only for a safe http(s) URL, `undefined` for `javascript:`/`data:`/other unsafe or unparseable schemes. */
export const getSafeHttpHref = (value?: string | null): string | undefined => {
  if (!value) return undefined;
  try {
    const url = new URL(value);
    return SAFE_HREF_PROTOCOLS.has(url.protocol) ? value : undefined;
  } catch {
    return undefined;
  }
};

/** Returns a same-origin, relative in-app path (`pathname + search`, hash dropped), or `undefined` for anything absolute, protocol-relative, obfuscated, or the sign-in/sign-up paths (to prevent a redirect loop). Complements, not replaces, Clerk's own redirect-target validation. */
export const sanitizeRedirectPath = (
  value?: string | null,
): string | undefined => {
  if (!value) return undefined;
  const trimmed = value.trim();
  if (!trimmed.startsWith('/')) return undefined;
  if (trimmed.startsWith('//') || trimmed.startsWith('/\\')) return undefined;
  if (trimmed.includes('\\')) return undefined;
  let url: URL;
  try {
    url = new URL(trimmed, 'http://localhost');
  } catch {
    return undefined;
  }
  if (url.origin !== 'http://localhost') return undefined;
  // Dot-segment normalisation (e.g. `/..//evil.com`) can collapse to a protocol-relative pathname the raw-string guard above never saw.
  if (url.pathname.startsWith('//')) return undefined;
  if (
    url.pathname === '/signin' ||
    url.pathname.startsWith('/signin/') ||
    url.pathname === '/signup' ||
    url.pathname.startsWith('/signup/')
  ) {
    return undefined;
  }
  return `${url.pathname}${url.search}`;
};
